export const PROPERTY_DEFAULT_HEIGHT = '38px';
